import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope, faHeadset, faComments } from '@fortawesome/free-solid-svg-icons';
import Section from '../ui/Section/Section';
import Button from '../ui/Button/Button';
import './ContactSection.css';

const ContactSection = ({ onContactClick }) => {
  return (
    <Section
      id="contato"
      background="gradient"
    >
      {/* CTA Principal */}
      <div className="contact__cta-banner">
        <div className="contact__cta-content">
          <div className="contact__cta-icon">
            <FontAwesomeIcon icon={faHeadset} />
          </div>
          <div className="contact__cta-text">
            <h2>Tem dúvidas sobre como podemos ajudar?</h2>
            <p>Nossa equipe de especialistas está pronta para apresentar a melhor solução para o seu negócio</p>
          </div>
        </div>
        <a
          href="https://wa.me/5546991107619"
          target="_blank"
          rel="noopener noreferrer"
          className="contact__cta-btn"
          aria-label="Fale com um especialista via WhatsApp"
        >
          <span className="contact__cta-btn-icon">
            <FontAwesomeIcon icon={faWhatsapp} />
          </span>
          <span>Fale com um especialista</span>
        </a>
      </div>

      {/* Grid de Contatos */}
      <div className="contact__grid">
        {/* WhatsApp Comercial */}
        <div className="contact__card contact__card--primary">
          <div className="contact__card-icon">
            <FontAwesomeIcon icon={faWhatsapp} />
          </div>
          <h3>WhatsApp Comercial</h3>
          <p>Tire suas dúvidas sobre o sistema e conheça nossas soluções</p>
          <a 
            href="https://wa.me/5546991107619" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button 
              variant="primary" 
              size="md"
              fullWidth
              icon={<FontAwesomeIcon icon={faWhatsapp} />}
            >
              Iniciar Conversa
            </Button>
          </a>
          <span className="contact__card-number">(46) 99110-7619</span>
        </div>

        {/* Suporte Técnico */}
        <div className="contact__card contact__card--support">
          <div className="contact__card-icon">
            <FontAwesomeIcon icon={faHeadset} />
          </div>
          <h3>Suporte Técnico</h3>
          <p>Atendimento especializado para clientes ativos</p>
          <a 
            href="https://wa.me/554632250131" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button 
              variant="secondary" 
              size="md"
              fullWidth
              icon={<FontAwesomeIcon icon={faWhatsapp} />}
            >
              Suporte via WhatsApp
            </Button>
          </a>
          <span className="contact__card-number">(46) 3225-0131</span>
        </div>

        {/* Telefone */}
        <div className="contact__card contact__card--phone">
          <div className="contact__card-icon">
            <FontAwesomeIcon icon={faPhone} />
          </div>
          <h3>Central de Atendimento</h3>
          <p>Ligue para nós e fale com nossa equipe</p>
          <a href="tel:+554632250131">
            <Button 
              variant="outline" 
              size="md"
              fullWidth
              icon={<FontAwesomeIcon icon={faPhone} />}
            >
              Ligar Agora
            </Button>
          </a>
          <span className="contact__card-number">(46) 3225-0131</span>
        </div>

      </div>

      {/* Redes Sociais */}
      <div className="contact__social">
        <h3>Visite nossas Redes Sociais</h3>
        <div className="contact__social-links">
          <a 
            href="https://www.instagram.com/Informezz" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact__social-link contact__social-link--instagram"
            aria-label="Instagram"
          >
            <FontAwesomeIcon icon={faInstagram} />
            <span>Instagram</span>
          </a>
          <a 
            href="https://www.facebook.com/people/Informezz-Sistemas/61557268662997/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact__social-link contact__social-link--facebook"
            aria-label="Facebook"
          >
            <FontAwesomeIcon icon={faFacebook} />
            <span>Facebook</span>
          </a>
          <a 
            href="https://youtu.be/wzY6DGE1TcE" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact__social-link contact__social-link--youtube"
            aria-label="YouTube"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
            <span>YouTube</span>
          </a>
        </div>
      </div>
    </Section>
  );
};

export default ContactSection;
